/* CocoRock — efeitos compartilhados:
   1. entrada suave das seções ao rolar;
   2. arrasto com mouse com inércia e encaixe suave ([data-cr-drag-scroll]);
   3. galerias de fotos ([data-cr-gallery]): setas, bolinhas e estado ativo.
   Tudo respeita "Reduzir movimento" do sistema. Toque usa a rolagem nativa. */
(function () {
  'use strict';
  if (window.CocoRockEffects) return;
  window.CocoRockEffects = true;

  var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  function reduce() { return reduceQuery.matches; }
  function behavior() { return reduce() ? 'auto' : 'smooth'; }

  /* ---------- 1. Entrada das seções ---------- */
  /* itens de carrossel horizontal (cards de produto no mobile, depoimentos) ficam de fora: fora da tela na horizontal eles só "apareceriam" ao arrastar */
  var REVEAL = '.cr-section, .cr-badges, .cr-ctaband, .cr-footer, .cr-origin__step, .cr-combo-inline__product';
  function initReveal() {
    if (reduce() || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    document.documentElement.classList.add('cr-fx');
    document.querySelectorAll(REVEAL).forEach(function (el) {
      /* só anima o que ainda está abaixo da dobra: nada visível "pisca" ao carregar */
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) return;
      var siblings = el.parentElement ? [].slice.call(el.parentElement.children) : [];
      var order = Math.min(5, Math.max(0, siblings.indexOf(el)));
      if (el.matches('.cr-origin__step, .cr-combo-inline__product')) el.style.transitionDelay = (order * 70) + 'ms';
      el.classList.add('cr-reveal');
      io.observe(el);
    });
  }

  /* ---------- 2. Arrasto com inércia (só mouse; toque é nativo) ---------- */
  function snapItems(el) {
    var host = el.children.length === 1 ? el.firstElementChild : el;
    return [].slice.call(host.children).filter(function (child) { return child.offsetWidth > 0; });
  }
  function nearestLeft(el, projected) {
    var base = el.getBoundingClientRect().left - el.scrollLeft;
    var best = projected, dist = Infinity;
    snapItems(el).forEach(function (item) {
      var left = item.getBoundingClientRect().left - base;
      var d = Math.abs(left - projected);
      if (d < dist) { dist = d; best = left; }
    });
    return Math.max(0, Math.min(best, el.scrollWidth - el.clientWidth));
  }
  function bindDrag(el) {
    if (el.dataset.crDragReady) return;
    el.dataset.crDragReady = 'true';
    var down = false, startX = 0, startScroll = 0, lastX = 0, lastT = 0, velocity = 0, moved = 0, releaseTimer = 0;
    el.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      down = true; moved = 0; velocity = 0;
      startX = lastX = event.clientX; startScroll = el.scrollLeft; lastT = performance.now();
      window.clearTimeout(releaseTimer);
      el.classList.add('is-dragging');
    });
    el.addEventListener('pointermove', function (event) {
      if (!down) return;
      var now = performance.now(), dx = event.clientX - lastX;
      if (Math.abs(event.clientX - startX) > 4 && !el.hasPointerCapture(event.pointerId)) el.setPointerCapture(event.pointerId);
      velocity = 0.8 * (dx / Math.max(1, now - lastT)) + 0.2 * velocity;
      lastX = event.clientX; lastT = now;
      moved = Math.max(moved, Math.abs(event.clientX - startX));
      el.scrollLeft = startScroll - (event.clientX - startX);
    });
    function release(event) {
      if (!down) return;
      down = false;
      if (event && el.hasPointerCapture(event.pointerId)) el.releasePointerCapture(event.pointerId);
      var projected = el.scrollLeft - velocity * (reduce() ? 0 : 260);
      el.scrollTo({ left: nearestLeft(el, projected), behavior: behavior() });
      /* devolve o scroll-snap só depois que a animação suave terminar */
      releaseTimer = window.setTimeout(function () { el.classList.remove('is-dragging'); }, reduce() ? 0 : 520);
    }
    el.addEventListener('pointerup', release);
    el.addEventListener('pointercancel', release);
    el.addEventListener('click', function (event) {
      if (moved > 6) { event.preventDefault(); event.stopPropagation(); moved = 0; }
    }, true);
    el.addEventListener('dragstart', function (event) { event.preventDefault(); });
  }
  function initDrag(scope) { (scope || document).querySelectorAll('[data-cr-drag-scroll]').forEach(bindDrag); }
  window.CocoRockDragScroll = bindDrag;

  /* ---------- 3. Galerias ---------- */
  function galleryOf(node) {
    var g = node.closest('[data-cr-gallery]');
    return g ? { g: g, track: g.querySelector('[data-cr-gallery-track]') } : null;
  }
  function slideIndex(p) { return Math.round(p.track.scrollLeft / Math.max(1, p.track.clientWidth)); }
  function goSlide(p, i) {
    var n = p.track.children.length;
    i = Math.max(0, Math.min(n - 1, i));
    p.track.scrollTo({ left: i * p.track.clientWidth, behavior: behavior() });
  }
  function syncGallery(p) {
    var i = slideIndex(p), n = p.track.children.length;
    p.g.querySelectorAll('[data-cr-gallery-dot]').forEach(function (dot, k) { dot.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    var prev = p.g.querySelector('[data-cr-gallery-prev]'), next = p.g.querySelector('[data-cr-gallery-next]');
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= n - 1;
  }
  document.addEventListener('click', function (event) {
    var b = event.target.closest('[data-cr-gallery-prev],[data-cr-gallery-next],[data-cr-gallery-dot]');
    if (!b) return;
    var p = galleryOf(b); if (!p || !p.track) return;
    event.preventDefault();
    if (b.hasAttribute('data-cr-gallery-dot')) goSlide(p, parseInt(b.dataset.index, 10) || 0);
    else goSlide(p, slideIndex(p) + (b.hasAttribute('data-cr-gallery-next') ? 1 : -1));
  });
  var pending = new Set();
  document.addEventListener('scroll', function (event) {
    var t = event.target;
    if (!t || !t.matches || !t.matches('[data-cr-gallery-track]') || pending.has(t)) return;
    pending.add(t);
    window.requestAnimationFrame(function () { pending.delete(t); var p = galleryOf(t); if (p) syncGallery(p); });
  }, true);
  window.CocoRockGallerySync = function (scope) {
    (scope || document).querySelectorAll('[data-cr-gallery]').forEach(function (g) { var p = { g: g, track: g.querySelector('[data-cr-gallery-track]') }; if (p.track) syncGallery(p); });
  };

  function boot(scope) { initDrag(scope); window.CocoRockGallerySync(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); initReveal(); });
  else { boot(document); initReveal(); }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
